import React, { useState } from 'react'
import { TableComponent } from '../../components/table'
import { NUMBER_OF_ITEMS_PER_PAGE } from '../../constants'

import { Button } from '../../components/button'
import CountCard from '../../components/cards/CountCard'
import { SearchInput } from '../../components/inputs/searchInput'
import { CreateVariantModal } from '../../components/modal/app_modals/createVariantModal'
import { PageHeader } from '../../components/typography/PageHeader'
import { CountCardContainer } from '../../components/wrapper/CountCardsContainer'
import { useModalControl } from '../../hooks/useModalControl'
import { useGetVariantsQuery } from '../../redux-toolkits/products/products.slice'
import { QueryProps } from '../../redux-toolkits/shared/shared.type'
import { SingleVariant } from '../../redux-toolkits/products/products.type'
const Variants: React.FC = () => {
  const [query, setQuery] = useState<QueryProps>({
    page: 1,
    limit: NUMBER_OF_ITEMS_PER_PAGE,
    search: undefined,
  })

  const [selectedVariant, setSelectedVariant] = useState<SingleVariant>()
  const [mode, setMode] = useState<'create' | 'edit'>('create')

  const { setModalOpen, modalOpen, handleModalOpen, handleModalClose, modal } =
    useModalControl()

  const { data, isFetching } = useGetVariantsQuery(
    {
      page: query.page,
      limit: query.limit,
      search: query.search,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  )

  return (
    <div>
      <PageHeader title="Variants" />

      <div className="w-full gap-4 flex flex-wrap items-center justify-between">
        <div className="!w-full md:!max-w-[400px]">
          <SearchInput
            searchFunction={(search) => {
              setQuery({
                ...query,
                search: search === '' ? undefined : search,
                page: 1,
              })
            }}
            placeholder="Search variants"
          />
        </div>

        <Button
          size="medium"
          label="Add Variant"
          primary
          onClick={() => {
            setMode('create')
            handleModalOpen('addVariantModal')
          }}
        />
      </div>

      <CountCardContainer>
        <CountCard
          isCurrency={false}
          text="Total variants count"
          count={data?.data.total ?? 0}
        />
      </CountCardContainer>

      <div className="w-full overflow-x-scroll">
        <TableComponent
          headers={['Name']}
          rows={
            data?.data.docs.length
              ? data.data.docs.map((singleVariant) => {
                  return {
                    id: singleVariant._id,
                    content: [
                      <button
                        key={`${singleVariant._id}-name`}
                        className="w-full text-left hover:underline"
                        onClick={(): any => {
                          setMode('edit')
                          handleModalOpen('addVariantModal')
                          setSelectedVariant(singleVariant)
                        }}
                      >
                        {singleVariant.name}
                      </button>,
                      // singleVariant.
                    ],
                  }
                })
              : []
          }
          name="variants-table"
          loading={isFetching}
          isEmpty={[undefined, 0].includes(data?.data?.docs.length)}
          currentPage={Number(query.page) ?? 1}
          totalDataCount={data?.data.total ?? 0}
          pageLimit={Number(query.limit)}
          onPageChange={(number) => {
            setQuery({ ...query, page: number })
          }}
        />
      </div>

      <CreateVariantModal
        open={modalOpen && modal === 'addVariantModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
          setSelectedVariant(undefined)
        }}
        onSuccessCallback={() => {
          setSelectedVariant(undefined)
        }}
        mode={mode}
        variant={selectedVariant}
      />
    </div>
  )
}

export default Variants
